module.exports = __webpack_public_path__ + "img/gradient.1d26a175.png";